define ['./dueToReportsModal.css'], () ->
  ($scope, $rootScope, $filter, $state, $uibModalInstance, RentappService, $http, RENTAPPLICATION_API_URL, Flash, $cacheFactory) ->
    $scope.theme_color = $rootScope.THEME_COLOR
    #$scope.reasonsUpdated = () ->
    #    scope.todays_date = $filter('date')(new Date(), 'yyyy-MM-dd');
    #    scope.reasonsSelected = _.filter(scope.reasons, (value, key) ->
    #        value == true
    #    ).length + _.filter(scope.customReason, (value, key) ->
    #        value == true
    #    ).length
    $scope.reason_count = 1

    $scope.reason_list = [
      "Credit score",
      "Past rental history or unable to verify rental history",
      "Income/Past employment history or unable to verify employment history",
      "Bankruptcy",
      "Delinquent past or present credit obligations",
      "Criminal Record",
      "Garnishment, attachment, foreclosure, repossession, collection action, or judgment",
      "Eviction",
      "Other"
    ]

    $scope.dropdown_toggle = {}

    $scope.selected_reasons = {}

    $scope.custom_reasons = {}

    $scope.toggle_cc = () ->
      $scope.email.cc_self = !$scope.email.cc_self

    $scope.set_reason = (reason_index, reason) ->
      $scope.selected_reasons[reason_index] = reason

    $scope.toggle_dropdown = (reason_index) ->
      $scope.dropdown_toggle[reason_index] = !$scope.dropdown_toggle[reason_index]

    $scope.toggle_dropdown_blur = (reason_index) ->
      console.log('toggle dropdown blur', reason_index)
      if $scope.dropdown_toggle[reason_index]
        $scope.dropdown_toggle[reason_index] = !$scope.dropdown_toggle[reason_index]

    $scope.format_custom_reasons = () ->
      for k,v of $scope.selected_reasons
        if v == 'Other'
          $scope.selected_reasons[k] = "Other: #{$scope.custom_reasons[k]}"

    $scope.reject_application = () ->

      $scope.format_custom_reasons()

      $scope.todays_date = $filter('date')(new Date(), 'yyyy-MM-dd')
      $scope.SUPPORT_EMAIL = $rootScope.SUPPORT_EMAIL
      $scope.reasons = (val for key, val of $scope.selected_reasons)
      
      # Setting custom reason enabled to false for now
      # TODO: Implement custom reason
      $scope.customReason =
        enabled: false

      send_data =
        application_id: $scope.application.id
        rejection_email_subject: $scope.email.subject
        rejection_email_body: ''
        rejection_reasons: $scope.reasons
        adverse_action: true
        with_email: true
        cc_self: $scope.email.cc_self

      $scope.rejecting = true
      $scope.reject_error = null
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/application/#{$scope.application.id}/reject_application/",
        send_data
      .then ->
        $cacheFactory.get('$http').removeAll()
        $state.go $state.current.name, $state.params, reload: true
      .catch (r) ->
        # TODO not really working, since it happens after modal close. Need to refactor. For now send button just disabled for empty body
        if r.status == 400
          Flash.create("danger", r.data.error)
        else
          Flash.create("danger", 'Unfortunately, an error has occured in processing this request. Please try again.')
      .finally ->
        $scope.rejecting = false



// WEBPACK FOOTER //
// ./directives/acceptRejectApplication/rejectApplication/dueToReportsModal/dueToReportsModal.coffee